import { render } from "./ExtraPages.vue?vue&type=template&id=5b9fee5d&scoped=true"
import script from "./ExtraPages.vue?vue&type=script&lang=js"
export * from "./ExtraPages.vue?vue&type=script&lang=js"

import "./ExtraPages.vue?vue&type=style&index=0&id=5b9fee5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9fee5d"]])

export default __exports__